import React from 'react';
import { useOrganizationQuery } from '../../../../api/queries/use-organization-query';
import type { Load, Organization, OrganizationLocation } from '../../../../types';
import { HereMap, HereMapRefObject } from '../../../here-maps/here-map';
import { OrganizationLocationBoxes } from '../../../here-maps/organization-location-boxes';
import { HereMapRoute } from '../../../here-maps/here-map-route';
import { OrgQueryKeys } from '../../../../api/config';
import { BulkScheduleHover } from './bulk-schedule-hover';

interface BulkScheduleMapProps {
    drafts: Load[];
    hoveredDraftIdState: {
        hoveredDraftId: number | null;
        setHoveredDraftId: (draftId: number | null) => void;
    }
}

export const BulkScheduleMap = (props: BulkScheduleMapProps) => {
    const { drafts, hoveredDraftIdState } = props;
    const { hoveredDraftId, setHoveredDraftId } = hoveredDraftIdState;
    const { data: organization } = useOrganizationQuery<Organization>('');
    const { data: organizationLocations = [] } = useOrganizationQuery<OrganizationLocation[]>(OrgQueryKeys.locations);
    const mapRef = React.useRef<HereMapRefObject>(null);

    return (
        <div
            style={{ display: 'flex', flex: 1, height: '50%', minHeight: '40vh', width: '100%' }}
        >
            {organization && <HereMap
                ref={mapRef}
                centerPosition={{ lat: organization.latitude, lng: organization.longitude }}
            >
                <OrganizationLocationBoxes />
                {drafts.map(draft => {
                    const routeWaypoints = draft.stops.map(stop => {
                        const organizationLocation = organizationLocations.find(x => x.id === stop.organizationLocationId);
                        return organizationLocation;
                    }).flat().filter(x => !!x);

                    return (
                        <HereMapRoute
                            key={draft.id}
                            calculateRouteFromWaypoints={true}
                            waypoints={routeWaypoints}
                            onRouteDrawn={() => {
                                mapRef.current?.fitMapToAllObjects(true, undefined, false);
                            }}
                            loadId={draft.id}
                            pointerEvents={{
                                onMouseEnter: () => setHoveredDraftId(draft.id),
                                onMouseLeave: () => setHoveredDraftId(null),
                            }}
                        />
                    )
                })}
                <BulkScheduleHover hoveredDraftId={hoveredDraftId} />
            </HereMap>}
        </div>
    )
}